import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import DLTVAdminPanel from './DLTVAdminPanel';
import Main from './Main';

class Router extends Component {
    render() {
        return (
            <Switch>
                <Route path="/admin/dltv" component={ DLTVAdminPanel } />
                <Route path="/" component={ Main } />
            </Switch>
        );
    }
}

export default Router;
